import React from "react";
import { GoShieldCheck } from "react-icons/go";

const SecurePaymentLock = ({ className = "" }) => {
    return (
        <div className={`secure-payment-lock ${className}`}>
            <GoShieldCheck className="lock-icon" size={20} />
            <span className="ms-2 fw-medium">Secure Payment Verified By VeriSign</span>
        </div>
    );
};

export default SecurePaymentLock;
